(function($) {

	$.fn.initColorsConfigurator = function() {

		return this.each(function() {

			var $cont = $(this);
			var $text = $cont.find(".text");

			$cont.find("label").each(function() {
				$(this).find("input").pseudoCheckbox({
					"trida": "radio",
					"tridaChecked": "active",
					"width": false,
					"height": false
				});
				$(this).find(".radio").css("background-color", $(this).find("input").attr("data-color"));
			});

			$cont.find("input").click(function() {
				$text.text($(this).attr("data-text"));
			}).filter(":checked").triggerHandler("click");

		});

	};

})(jQuery);